var React = require('react');

function List (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"1.29411","x2":"19","y2":"1.29411","strokeWidth":"2","key":0}),React.createElement("line",{"y1":"5.41176","x2":"19","y2":"5.41176","strokeWidth":"2","key":1}),React.createElement("line",{"y1":"9.52942","x2":"19","y2":"9.52942","strokeWidth":"2","key":2}),React.createElement("line",{"y1":"13.6471","x2":"19","y2":"13.6471","strokeWidth":"2","key":3}),React.createElement("line",{"y1":"17.7647","x2":"19","y2":"17.7647","strokeWidth":"2","key":4})]);
}

List.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = List;

List.default = List;
